import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, ChevronRight, Loader2, Send, CheckCircle2, ArrowLeft } from "lucide-react";
import api, { apiErrorMessage } from "../services/api";

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) { setError("Veuillez saisir votre adresse email."); return; }
    setLoading(true); setError("");
    try {
      await api.post("/auth/forgot-password", { email: email.trim(), base_url: window.location.origin });
      setSent(true);
    } catch (err) {
      setError(apiErrorMessage(err, "Une erreur est survenue. Réessayez."));
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-[1440px] mx-auto px-5 py-12" data-testid="forgot-password-page">
      <div className="flex items-center gap-1.5 text-[14px] text-slate-400 mb-8">
        <Link to="/" className="hover:text-[#FF3B3B]">Accueil</Link>
        <ChevronRight size={15} />
        <Link to="/connexion" className="hover:text-[#FF3B3B]">Connexion</Link>
        <ChevronRight size={15} />
        <span className="text-slate-50 font-semibold">Mot de passe oublié</span>
      </div>

      <div className="max-w-md mx-auto bg-[#10131A] rounded-2xl border border-[#1E232D] p-6 sm:p-8 shadow-sm">
        {sent ? (
          <div data-testid="forgot-success" className="text-center py-4">
            <CheckCircle2 size={44} className="mx-auto text-emerald-400 mb-3" />
            <h1 className="font-extrabold italic uppercase tracking-tight text-slate-50 text-2xl mb-2">Vérifiez vos emails</h1>
            <p className="text-slate-300 text-[15px]">Si un compte existe pour <strong>{email}</strong>, vous recevrez un lien pour réinitialiser votre mot de passe (valable 1 heure).</p>
            <Link to="/connexion" className="btn-orange inline-flex items-center gap-2 rounded-lg px-6 py-3 font-bold mt-6"><ArrowLeft size={18} /> Retour à la connexion</Link>
          </div>
        ) : (
          <>
            <h1 className="font-extrabold italic uppercase tracking-tight text-slate-50 text-2xl mb-1">Mot de passe oublié ?</h1>
            <p className="text-slate-400 text-[14px] mb-6">Saisissez votre email, nous vous enverrons un lien de réinitialisation.</p>
            <form onSubmit={submit} className="space-y-4">
              <div>
                <label className="block text-[14px] font-semibold text-slate-50 mb-1.5">Adresse email</label>
                <div className="flex items-center border-2 border-[#222735] rounded-lg px-3 focus-within:border-[#E01F1F] transition-colors">
                  <Mail size={18} className="text-slate-500" />
                  <input data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="vous@email.fr" className="flex-1 px-3 py-3 outline-none text-slate-50" />
                </div>
              </div>
              {error && <div data-testid="forgot-error" className="text-[14px] text-red-500">{error}</div>}
              <button data-testid="forgot-submit" type="submit" disabled={loading} className="btn-orange w-full rounded-lg py-3.5 font-bold text-lg flex items-center justify-center gap-2 disabled:opacity-70">
                {loading ? <Loader2 className="animate-spin" size={18} /> : <Send size={18} />} Envoyer le lien
              </button>
              <Link to="/connexion" className="block text-center text-[14px] text-[#FF3B3B] font-semibold hover:underline mt-2">Retour à la connexion</Link>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
